const ImagePlaceholder = () => (
  <div className="image-thumbnail-placeholder">
    <i className='bx bx-image'></i>
  </div>
);

export default ImagePlaceholder;